import { graphGetAll } from '@/graph/client';
import { CAPABILITY_SCOPES } from '@/auth/scopes';
import type { Organization } from '@/graph/types';

/** C2 — tenant organisation metadata (name, id, verified domains, tenant type). */
export async function getOrganization(): Promise<Organization | null> {
  const orgs = await graphGetAll<Organization>('/organization', {
    scopes: CAPABILITY_SCOPES.C2.scopes,
    query: {
      $select: 'id,displayName,verifiedDomains,tenantType,createdDateTime',
    },
  });
  return orgs[0] ?? null;
}
